/**
 * R2 utility functions for generating public URLs
 */

/**
 * Get public URL for an R2 path
 * Uses the proxy endpoint to serve images from R2
 * @param {string} r2Path - The R2 path (e.g., "rooms/1/1234567890-image.jpg")
 * @returns {string} Public URL via proxy endpoint
 */
export function getR2PublicUrl(r2Path) {
  if (!r2Path) return null

  let key = String(r2Path).trim()
  if (!key) return null

  if (key.startsWith('http://') || key.startsWith('https://')) {
    const proxyMatch = key.match(/\/api\/scheduler\/rooms\/image\/(.+)$/)
    if (proxyMatch) key = proxyMatch[1]
    else return key
  }

  key = key.replace(/^\/+/, '')
  if (key.startsWith('api/scheduler/rooms/image/')) {
    key = key.slice('api/scheduler/rooms/image/'.length)
  }

  return `/api/scheduler/rooms/image/${key}`
}

/**
 * Check if a path is an R2 path (starts with "rooms/")
 * @param {string} path - The path to check
 * @returns {boolean}
 */
export function isR2Path(path) {
  return path && typeof path === 'string' && path.startsWith('rooms/')
}
